<template>
  <v-card class="text-xs-center">
    <h1 class="pa-3">Approve Events Log</h1>
    <log-table :itemList="eventLogApproval" :isLoading="isLoading" />
  </v-card>
</template>

<script>
import LogTable from "@/components/back-office/Merchant/LogEvent/LogTable.vue";
import { mapState, mapActions } from "vuex";
export default {
  data() {
    return {
      isLoading: false,
    };
  },
  async created() {
    this.isLoading = true;
    await this.fetchData();
    this.isLoading = false;
  },
  computed: {
    ...mapState({
      eventLogApproval: (state) => state.fetchStoreApproveBack.eventLogApproval,
    }),
  },
  methods: {
    ...mapActions({
      fetchData: "fetchStoreApproveBack/getEventLogApproval",
    }),
  },
  components: { "log-table": LogTable },
  destroyed() {
    this.$store.commit("fetchStoreApproveBack/resetState");
  },
  mounted() {
    const path = [
      {
        text: "Select province",
        disabled: false,
        href: "/weserve_admin_login/select/",
      },
      {
        text: "Select service",
        disabled: false,
        href: "/weserve_admin_login/control/" + this.$route.params.province,
      },
      {
        text: "Store&Product",
        disabled: false,
        href:
          "/weserve_admin_login/control/" +
          this.$route.params.province +
          "/storeandproduct/storemanage",
      },
      {
        text: "Contact Store Approve",
        disabled: true,
        href:
          "/weserve_admin_login/control/" +
          this.$route.params.province +
          "/storeandproduct/contactstoreapprove",
      },
    ];
    this.$store.commit("backOffice/saveRecentRoute", path);
  },
};
</script>

<style></style>
